import * as blogConst from 'app/constants/blogs';
import { UnknownAction } from '@reduxjs/toolkit';

const blogs = (state = [], action: UnknownAction) => {
  switch (action.type) {
    case blogConst.FETCH_BLOG_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}

export default blogs
